<template>
  <div>
    <template v-if="clip !== null">
      <a :href="clip.url" v-if="isVideo" target="_blank"><img :src="clip.thumbnail_url"/></a>
      <video v-if="!isVideo" :src="clip.media_url"
        :poster="clip.thumbnail_url"
        :autoPlay="false"
        controls="true"
        :muted="true"
        />
    </template>
    <template v-if="clip === null">
      <img src="@/assets/TOPCLIP_REMASTERED.png"/>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Clip',
  props: {
    clip: Object
  },
  computed: {
    ...mapGetters([
      'isVideo'
    ])
  }
}
</script>

<style>

video, img {
  width: calc(100vw - 8px);
  height:56.25vw
}

video, img {
  object-fit: contain;
}

</style>
